import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingCart, Users, Mail, Settings, FileText, Share2, Send, LogOut, Menu, X, Layout, Star, Tag, BarChart2, Eye, Banknote } from 'lucide-react';
import { useAuth, useSettings } from '../../App';

const AdminLayout = ({ children, title }) => {
  const { logout } = useAuth();
  useSettings();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Auth guard is handled by ProtectedRoute in App.js — no race condition here.

  const navItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/admin/dashboard' },
    { icon: Package, label: 'Produkty', path: '/admin/produkty' },
    { icon: ShoppingCart, label: 'Zamówienia', path: '/admin/zamowienia' },
    { icon: Banknote, label: 'Przelewy', path: '/admin/przelewy' },
    { icon: Tag, label: 'Kody Promo', path: '/admin/promocje' },
    { icon: BarChart2, label: 'Analityka', path: '/admin/analityka' },
    { icon: Eye, label: 'Odwiedziny', path: '/admin/odwiedziny' },
    { icon: Users, label: 'Kontakty', path: '/admin/kontakty' },
    { icon: Mail, label: 'Szablony Email', path: '/admin/szablony' },
    { icon: Send, label: 'Wysyłki', path: '/admin/wysylki' },
    { icon: Layout, label: 'CMS Sekcje', path: '/admin/cms' },
    { icon: Star, label: 'Opinie', path: '/admin/opinie' },
    { icon: Share2, label: 'Social Media', path: '/admin/social' },
    { icon: FileText, label: 'Dokumenty', path: '/admin/dokumenty' },
    { icon: Settings, label: 'Ustawienia', path: '/admin/ustawienia' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-[#050505] flex">
      {/* Sidebar - Desktop */}
      <aside className="hidden lg:flex flex-col w-64 bg-[#0B0F0E] border-r border-white/5">
        <div className="p-6 border-b border-white/5">
          <Link to="/admin/dashboard" className="text-xl font-bold">
            <span className="text-white">Mr</span>
            <span className="text-[#10b981]">Minds.</span>
          </Link>
          <p className="text-[#6B7280] text-xs mt-1">Panel Admina</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <Link key={item.path} to={item.path} className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}>
              <item.icon size={20} />
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5">
          <button onClick={handleLogout} className="admin-nav-item w-full text-red-400 hover:text-red-300 hover:bg-red-500/10">
            <LogOut size={20} />
            Wyloguj
          </button>
        </div>
      </aside>

      {/* Mobile Sidebar */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/60" onClick={() => setSidebarOpen(false)}></div>
          <aside className="absolute left-0 top-0 bottom-0 w-64 bg-[#0B0F0E] border-r border-white/5">
            <div className="p-6 border-b border-white/5 flex justify-between items-center">
              <span className="text-xl font-bold">
                <span className="text-white">Power</span>
                <span className="text-[#10b981]">Mindset.</span>
              </span>
              <button onClick={() => setSidebarOpen(false)} className="text-white">
                <X size={24} />
              </button>
            </div>
            <nav className="p-4 space-y-1">
              {navItems.map((item) => (
                <Link key={item.path} to={item.path} onClick={() => setSidebarOpen(false)} className={`admin-nav-item ${location.pathname === item.path ? 'active' : ''}`}>
                  <item.icon size={20} />
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="p-4 border-t border-white/5">
              <button onClick={handleLogout} className="admin-nav-item w-full text-red-400">
                <LogOut size={20} />
                Wyloguj
              </button>
            </div>
          </aside>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="h-16 bg-[#0B0F0E] border-b border-white/5 flex items-center justify-between px-4 lg:px-6">
          <div className="flex items-center gap-4">
            <button onClick={() => setSidebarOpen(true)} className="lg:hidden text-white">
              <Menu size={24} />
            </button>
            <h1 className="text-xl font-bold text-white">{title}</h1>
          </div>
          <Link to="/" target="_blank" className="text-[#9CA3AF] hover:text-[#10b981] text-sm">
            Zobacz stronę →
          </Link>
        </header>
        <main className="flex-1 p-4 lg:p-6 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;